<template>
  <!--选择开票公司-->
  <div class="select-company-popup">
    <van-popup v-model="visible" position="bottom">
      <div class="popup-title">选择所属机构</div>
      <div class="company-list">
        <div class="company-item" :class="{ 'active': item.name == activeName }" v-for="item in explainList" :key="item.name" @click="activeName = item.name">
          <i class="icon icon-tongguo"></i>
          {{ item.name }}
        </div>
      </div>
      <div class="btn-list">
        <div class="btn" @click="visible = false">取消</div>
        <div class="btn active" @click="save">确定</div>
      </div>
    </van-popup>
  </div>
</template>
  
<script>
import { config } from './selectCompanyPopup.config.js';
export default {
  mixins: [config],
  data() {
    return {
      activeName: '',
      visible: false
    };
  },
  props: [],
  mounted() {},
  methods: {
    open(item) {
      this.visible = true;
      this.activeName = item.name || '';
    },
    save() {
      const bean = this.explainList.find(item=>item.name == this.activeName);
      this.$emit('save', bean);
      this.visible = false;
    }
  }
};
</script>
  
<style lang="scss" scoped>
@import './selectCompanyPopup.scss';
</style>
  